import { Link } from "react-router-dom";
import { PageHeader } from "../components/ui";

export function AdminDashboardPage() {
  return (
    <div>
      <PageHeader
        title="Admin Dashboard"
        subtitle="Manage users, tests, assignments, and grading."
      />
      <ul className="dashboard-links">
        <li>
          <Link to="/admin/users">
            User management
            <div className="page-subtitle">
              Create students, reset passwords, import CSV.
            </div>
          </Link>
        </li>
        <li>
          <Link to="/admin/tests">
            Test management
            <div className="page-subtitle">
              Build tests, edit questions, assign and grade submissions.
            </div>
          </Link>
        </li>
      </ul>
    </div>
  );
}
